export const site = {
  name: "Bronco Electric Inc.",
  tagline: "Design. Construct. Maintain.",
  yearsExperience: 30,
  locations: [
    {
      label: "Bakersfield, California",
      address: "1711 Art Street, Bakersfield, CA 93312",
      phone: "661-589-9439",
      phoneHref: "tel:+16615899439",
      license: "CA License #427730",
    },
    {
      label: "Nampa, Idaho",
      address: "2220 Cortland Place, Nampa, ID 83687",
      phone: "208-572-7444",
      phoneHref: "tel:+12085727444",
      license: "ID License #039308",
    },
  ],
  primaryPhone: "661-589-9439",
  primaryPhoneHref: "tel:+16615899439",
  email: "info@broncoelectric.com",
  emailHref: "mailto:info@broncoelectric.com",
  hours: "Mon–Fri: 7:00 AM – 4:00 PM",
  certifications: ["CALCTP", "IBEW", "NECA", "Tesla Certified Installer"],
};

export const services = [
  {
    title: "Commercial Electrical",
    description:
      "Complete electrical systems for offices, retail, and commercial buildings — built to code and built to last.",
    icon: "building",
  },
  {
    title: "Industrial Electrical",
    description:
      "Heavy-duty power distribution, controls, and maintenance for plants, warehouses, and facilities.",
    icon: "factory",
  },
  {
    title: "Municipal Projects",
    description:
      "Reliable, compliant electrical work for cities, schools, and public infrastructure projects.",
    icon: "landmark",
  },
  {
    title: "Residential Service",
    description:
      "Panel upgrades, rewires, lighting, and troubleshooting for homeowners across Kern County.",
    icon: "home",
  },
  {
    title: "EV Charging Solutions",
    description:
      "Tesla-certified installation of home and commercial EV charging stations, done right the first time.",
    icon: "bolt",
  },
  {
    title: "Title 24 Compliance",
    description:
      "Energy-efficient lighting and systems that keep your project fully Title 24 compliant.",
    icon: "leaf",
  },
];

export const stats = [
  { value: "30+", label: "Years in Business" },
  { value: "100%", label: "Licensed & Insured" },
  { value: "1st", label: "Time, Done Right" },
  { value: "2", label: "Locations: CA & ID" },
];

export const reasons = [
  {
    title: "30+ Years of Experience",
    description:
      "Three decades serving Kern County means we've seen it all — and we deliver dependable results every time.",
  },
  {
    title: "Done Right the First Time",
    description:
      "Our experts complete projects correctly the first time with high-quality, lasting workmanship.",
  },
  {
    title: "Certified & Trusted",
    description:
      "CALCTP, IBEW, NECA, and Tesla-certified — credentials that back up our reputation.",
  },
  {
    title: "Competitive Rates",
    description:
      "Premium electrical work shouldn't break the budget. Our rates stay very competitive.",
  },
];

export const testimonials = [
  {
    quote:
      "Bronco Electric handled our commercial build-out flawlessly. On time, on budget, and the crew was professional from start to finish.",
    name: "Daniel R.",
    role: "Property Developer, Bakersfield",
  },
  {
    quote:
      "They installed our Tesla charger the same week we called. Clean work and they explained everything. Highly recommend.",
    name: "Marisol G.",
    role: "Homeowner, Kern County",
  },
  {
    quote:
      "We've used Bronco for multiple municipal projects. Always compliant, always reliable. They're our go-to electrical contractor.",
    name: "City Facilities Manager",
    role: "Public Works Department",
  },
];
